import React, { useEffect, useState } from "react";
import { Form, Input, Button, Checkbox } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../../../reducers/loggedinuser";
import { storeToken, loginAuth } from "../../../services/AuthServices";
import Alert from "../../common/alert";
import "./login.css";

const Login = () => {
  const [isRememberMe, setIsRememberMe] = useState(false);
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth);

  const handleClick = () => {
    navigate("/register");
  };

  const handleLoginClick = () => {
    navigate("/");
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        loginAuth(values.email, values.password, "STUDENT")
          .then((response) => {
            if (response.data.success) {
              // console.log(response.data);
              dispatch(login(response.data.user));
              localStorage.setItem("isRememberMe", isRememberMe);
              storeToken(response.data.token);
              localStorage.setItem("type", "Student");
            } else {
              Alert(
                "error",
                "Error!",
                response.data.message.replaceAll("TRAINER", "TEACHER")
              );
            }
          })
          .catch((error) => {
            const message = error.response
              ? error.response.data.message
              : error.message;
            Alert("error", "Error!", message);
          });
      })
      .catch((err) => {
        console.log("Validation Failed:", err);
      });
  };

  useEffect(() => {
    if (user?.isLoggedIn && user?.userOptions?.[0]?.link) {
      navigate(user.userOptions[0].link);
    }
  }, [user, navigate]);

  return (
    <div className="login-container">
      <div className="login-student-inner">
        <div className="space-btw">
          <Button className="login-btn" ghost onClick={handleLoginClick}>
            Sign In
          </Button>
          <Button className="register-btn" ghost onClick={handleClick}>
            Register
          </Button>
        </div>
        <div className="login-log">
          <img src="/assets/login-logo.png" alt="logo" height="200px" />
        </div>
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item
            label={<span style={{ color: "white" }}>Email</span>}
            colon={false}
            hasFeedback
            name="email"
            rules={[
              { type: "email", message: "The input is not valid E-mail!" },
              { required: true, message: "Please input your E-mail!" },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>

          <Form.Item
            label={<span style={{ color: "white" }}>Password</span>}
            colon={false}
            hasFeedback
            name="password"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Login
            </Button>
          </Form.Item>

          <div className="space-btw">
            <Checkbox onChange={(e) => setIsRememberMe(e.target.checked)}>
              Remember me?
            </Checkbox>
            <Link to="/forgot-password">Forgot your password?</Link>
          </div>
        </Form>

        <div className="login-footer">
          <Link to="/admin">Tutor/Admin Sign In</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
